"use client";

import { Area, AreaChart, Line, LineChart } from "recharts";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartConfig, ChartContainer } from "@/components/ui/chart";

const data = [
  {
    revenue: 10400,
    subscription: 40,
  },
  {
    revenue: 14405,
    subscription: 90,
  },
  {
    revenue: 9400,
    subscription: 200,
  },
  {
    revenue: 8200,
    subscription: 278,
  },
  {
    revenue: 7000,
    subscription: 89,
  },
  {
    revenue: 9600,
    subscription: 239,
  },
  {
    revenue: 11244,
    subscription: 78,
  },
  {
    revenue: 26475,
    subscription: 89,
  },
];

const chartConfig = {
  revenue: {
    label: "Receita",
    color: "var(--primary)",
  },
  subscription: {
    label: "Assinaturas",
    color: "var(--primary)",
  },
} satisfies ChartConfig;

export function CardsStats() {
  return (
    <div className="grid gap-4 @xl:grid-cols-2 @5xl:grid-cols-1 @7xl:grid-cols-2">
      <Card>
        <CardHeader>
          <CardDescription>Receita Total</CardDescription>
          <CardTitle className="text-3xl">$15.231,89</CardTitle>
          <CardDescription>+20.1% desde o mês passado</CardDescription>
        </CardHeader>
        <CardContent className="pb-0">
          <ChartContainer config={chartConfig} className="h-[90px] w-full">
            <LineChart
              data={data}
              margin={{
                top: 5,
                right: 10,
                left: 10,
                bottom: 0,
              }}
            >
              <Line
                type="monotone"
                strokeWidth={2}
                dataKey="revenue"
                stroke="var(--color-revenue)"
                activeDot={{
                  r: 6,
                }}
              />
            </LineChart>
          </ChartContainer>
        </CardContent>
      </Card>
      <Card className="relative flex flex-col overflow-hidden pb-0 @5xl:hidden @7xl:flex">
        <CardHeader>
          <CardDescription>Assinaturas</CardDescription>
          <CardTitle className="text-3xl">+2.350</CardTitle>
          <CardDescription>+180.1% desde o mês passado</CardDescription>
        </CardHeader>
        <CardContent className="relative mt-auto flex-1 p-0">
          <ChartContainer config={chartConfig} className="relative size-full h-[90px]">
            <AreaChart
              data={data}
              margin={{
                left: 0,
                right: 0,
              }}
              className="size-fit"
            >
              <Area
                dataKey="subscription"
                fill="var(--color-subscription)"
                fillOpacity={0.05}
                stroke="var(--color-subscription)"
                strokeWidth={2}
                type="monotone"
              />
            </AreaChart>
          </ChartContainer>
        </CardContent>
      </Card>
    </div>
  );
}
